import { useEffect, useState } from 'react';
import { LeadsService } from '../../../services/leads/leadsService';
import { State } from '../../../type/entities/state-type';

/*-----------------------------------------------------------------------------------------------
* EN: Hook to manage lead states fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de estados de renovaciones.
-----------------------------------------------------------------------------------------------*/

const useLeadStates = () => {

    const [data, setData] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchLeadStates = async () => {
        setIsLoading(true);
        try {
            const service = new LeadsService();
            const response = await service.getLeadStatuses();
            const fetchedData = response.getResponseData();

            const toBool = (v: unknown) => v === true || v === 't' || v === 'true' || v === 1;
            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: State) => ({
                    value: data.id,
                    label: data.name,
                    color: data.color,
                    statusOrder: data.entityOrder,
                    initialStatus: data.initialStatus,
                    satisfactoryStatus: toBool(data.satisfactoryStatus),
                    unsatisfactoryStatus: toBool(data.unsatisfactoryStatus),
                    requiresKoReason: toBool(data.requiresKoReason),
                }));
                setData(mappedData);
            }
        } catch (error) {
            console.log('Error fetching lead states:', error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchLeadStates();
    }, []);

    const getLeadStatesList = (notShowStatusID?: string | null) => {
        if (notShowStatusID) return data.filter((status) => status.value !== notShowStatusID);
        return data;
    };

    return { fetchLeadStates, getLeadStatesList, isLoadingLeadStates: isLoading };
}

export default useLeadStates;